import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";

const Carousel = [
  {
    img: require("../../../src/assets/img6.jpeg"),
    title: "Débarras experts à Lyon",
    text: "Intervention rapide et professionnels",
  },
  {
    img: require("../../../src/assets/d5.PNG"),
    title: "Devis gratuits",
    text: "Interventions sous 24/48h",
  },
  {
    img: require("../../../src/assets/img1.jpeg"),
    title: "Appartement, maison, cave, grenier, locaux profesionnels",
    text: "Vos biens protégés",
  },
  {
    img: require("../../../src/assets/img6.jpeg"),
    title: "Débarras après succession",
    text: "Déménagement",
  },
];

const ImageCarousel = () => {
  const [activeTab, setactiveTab] = useState(0);
  const carouselLength = Carousel.length;

  const handleNextItem = () => {
    if (activeTab === carouselLength - 1) {
      setactiveTab(0);
    } else {
      setactiveTab(activeTab + 1);
    }
  };
  const handleBackItem = () => {
    if (activeTab === 0) {
      setactiveTab(carouselLength - 1);
    } else {
      setactiveTab(activeTab - 1);
    }
  };

  // 🔥 AUTO PLAY
  useEffect(() => {
    const interval = setInterval(() => {
      setactiveTab((prev) => (prev === carouselLength - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [carouselLength]);

  const { text, bg } = useContext(ThemeContext);

  return (
    <div className="absolute h-full top-0 bottom-0 overflow-hidden right-0 left-0 z-20">
      <div className="w-full h-full relative">
        {Carousel.map((el, i) => (
          <motion.div
            key={i}
            className={`${
              activeTab === i ? "block" : "hidden"
            } h-full md:h-auto`}
          >
            <div
              className={`px-[40px] pt-16 lg:pt-0 lg:px-[110px] xl:px-[190px] h-full flex items-center justify-end text-right left-0 uppercase absolute w-full text-white z-40`}
            >
              <AnimatePresence>
                {activeTab === i && (
                  <motion.div
                    initial={{ opacity: 0, y: 100, display: "none" }}
                    animate={{ opacity: 1, y: 0, display: "flex" }}
                    // exit={{ display: "none" }}
                    transition={{
                      delay: 0.3,
                      duration: 1,
                      ease: "easeOut",
                      type: "spring",
                    }}
                    className="flex flex-col items-end"
                  >
                    <h2 className="text-[16px] lg:text-[28px] font-bold">
                      {el.title}
                    </h2>
                    <h2
                      className={`${text} text-[16px] lg:text-[28px] font-bold`}
                    >
                      {el.text}
                    </h2>
                    <Link to={"/devis"}>
                      <button className={`${bg} text-white text-[13px] font-semibold px-[28px] py-[15px] mt-2 transition-transform duration-300 hover:scale-105`}>
                        OBTENIR UN DEVIS
                      </button>
                    </Link>
                    <div className="flex items-start gap-1">
                      <button
                        onClick={handleBackItem}
                        className={`${bg} p-2 mt-2 text-white border border-transparent hover:border-gray-400 transition-transform duration-300 hover:scale-110 cursor-pointer`}
                      >
                        <BiChevronLeft className="text-2xl" />
                      </button>
                      <button
                        onClick={handleNextItem}
                        className={`${bg} p-2 mt-2 text-white border border-transparent hover:border-gray-400 transition-transform duration-300 hover:scale-110 cursor-pointer`}
                      >
                        <BiChevronRight className="text-2xl" />
                      </button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
            <motion.img
              animate={{
                opacity: activeTab === i ? 1 : 0,
                x: activeTab === i ? 0 : -200,
              }}
              transition={{ bounce: 2 }}
              className="object-cover w-full h-full"
              src={el.img}
              alt={el.img}
            />
          </motion.div>
        ))}
        <div className="absolute top-0 bottom-0 right-0 left-0 bg-gray-900/80" />
      </div>
    </div>
  );
};

export default ImageCarousel;
